<form id="myForm" (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div fxFlex="1 1 100%" fxLayout="row" fxFlexFill fxLayoutGap="20px">


    <div fxFlex="400px" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="20px">

      <div fxFlex class="box" fxLayout="column">
        <h5>Baseline multiplliers</h5>
        <app-staff-point-baseline [formControl]="form.controls.baseline"></app-staff-point-baseline>
      </div>

      <div fxFlex class="box" fxLayout="column">
        <mat-slide-toggle color="primary" formControlName="initialPointsEnabled">
          <label>Initial points</label>
        </mat-slide-toggle>
        @if (form.value.initialPointsEnabled) {
          <div fxLayout="row">
            <mat-form-field fxFlex>
              <mat-label>Initial points</mat-label>
              <input matInput type="number" placeholder="" formControlName="initialPoints" maxlength="6"
                autocomplete="off" step="1">
            </mat-form-field>
          </div>
        }
      </div>


      <div fxFlex class="box" fxLayout="column">
        <mat-slide-toggle color="primary" formControlName="productLimitEnabled">
          <label>Product Limits</label>
        </mat-slide-toggle>
        @if (form.value.productLimitEnabled) {
          <app-staff-product-limit [formControl]="form.controls.productLimit">
          </app-staff-product-limit>
        }
      </div>


      <div fxFlex class="box" fxLayout="column">
        <mat-slide-toggle color="primary" formControlName="pointResetEnabled">
          <label>Reset points</label>
        </mat-slide-toggle>
        @if (form.value.pointResetEnabled) {
          <app-staff-point-reset [formControl]="form.controls.pointReset">
          </app-staff-point-reset>
        }
      </div>

      <div fxFlex class="box" fxLayout="column">
        <mat-slide-toggle color="primary" formControlName="raffleTicketsEnabled">
          <label>Raffle tickets</label>
        </mat-slide-toggle>
        @if (form.value.raffleTicketsEnabled) {
          <div fxLayout="row">
            <mat-form-field fxFlex>
              <mat-label>Points for one raffle ticket</mat-label>
              <input matInput type="number" placeholder=""
                formControlName="pointsForRaffleTicket" maxlength="6" autocomplete="off" step="1">
            </mat-form-field>
          </div>
        }
      </div>
      <!--<pre>{{ form.value | json }}</pre>-->


    </div>


  </div>
</form>